import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { FaSearch, FaTimesCircle } from 'react-icons/fa'; // For icons
import './ModalListCostos.css'; // Import your custom CSS for styling

const ModalListCostos = ({ estado, onCloseModal, listCostos }) => {
  const [filter, setFilter] = useState('');

  // Filter the listCostos based on the search input
  const filteredCostos = listCostos.filter((costo) => {
    const searchTerm = filter.toLowerCase();
    const cod = costo.label.split(' ')[0].toLowerCase();
    const producto = costo.label.split(' ').slice(1).join(' ').toLowerCase();
    return cod.includes(searchTerm) || producto.includes(searchTerm);
  });

  return (
    <Modal
      show={estado}
      onHide={onCloseModal}
      size="lg"
      centered
      className="custom-modal"
    >
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title>Lista de Costos</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <Form className="mb-4">
          <InputGroup className="search-input-group">
            <InputGroup.Text className="input-group-text-custom">
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Filtrar por Código o Servicio/Producto"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="search-input"
            />
            {filter && (
              <Button
                variant="link"
                className="clear-button"
                onClick={() => setFilter('')}
              >
                <FaTimesCircle />
              </Button>
            )}
          </InputGroup>
        </Form>
        <div className="table-responsive">
          <Table  bordered className="custom-table mb-0">
            <thead>
              <tr>
                <th style={{ width: '120px', minWidth: '90px', whiteSpace: 'nowrap' }}>Código</th>
                <th style={{
                  width: '70%',
                  minWidth: '120px',
                  maxWidth: '240px',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden'
                }}>
                  Servicio/Producto
                </th>
                <th style={{ width: '140px', minWidth: '110px', whiteSpace: 'nowrap' }}>Precio</th>
              </tr>
            </thead>
            <tbody>
              {filteredCostos.length > 0 ? (
                filteredCostos.map((costo) => (
                  <tr key={costo.value}>
                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>
                      {costo.label.split(' ')[0]}
                    </td>
                    <td
                      style={{
                        maxWidth: '220px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle'
                      }}
                      title={costo.label.split(' ').slice(1).join(' ')}
                    >
                      {costo.label.split(' ').slice(1).join(' ')}
                    </td>
                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>
                      {costo.precioventa
                        ? costo.precioventa.toLocaleString('es-PY') + ' Gs'
                        : 'N/A'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center no-results">
                    <FaTimesCircle className="no-results-icon" />
                    No se encontraron resultados
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer-custom">
        <Button
          variant="danger"
          onClick={onCloseModal}
          className="close-button"
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalListCostos;